import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, firstValueFrom } from 'rxjs';
import { EnvService } from '../services/env.service';
import {
    ImageUploadResponse,
    LoginRequest,
    LoginResponse,
    ResetData,
    ResetPasswordParams,
    response,
} from 'src/interface/user';
import {
    ApiResponse,
    ProfileRequest,
    ResetprofileData,
    resetResponse,
} from 'src/interface/profile';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    public languageChange = new Subject();
    languageChange$ = this.languageChange.asObservable();
    constructor(private http: HttpClient, private env: EnvService) {}

    login(user: LoginRequest): Promise<LoginResponse> {
        return firstValueFrom(
            this.http.post<LoginResponse>(
                this.env.siteApiUrl + 'web/login',
                user
            )
        );
    }

    refreshToken(): Promise<LoginResponse> {
        return firstValueFrom(
            this.http.get<LoginResponse>(
                this.env.siteApiUrl + 'web/refresh-token',
                {
                    withCredentials: true,
                }
            )
        );
    }

    autoLogin(): Promise<LoginResponse> {
        return firstValueFrom(
            this.http.post<LoginResponse>(
                this.env.siteApiUrl + 'web/auto-login',
                undefined,
                { withCredentials: true } /*
                withCredentials() makes your browser include cookies and authentication headers in your XHR request.
                 If your service depends on any cookie (including session cookies), it will only work with this option set.
                
                */
            )
        );
    }

    logout() {
        return this.http.post(this.env.siteApiUrl + 'web/logout', {});
    }

    checkEmailExists(email) {
        return this.http.get(
            this.env.siteApiUrl + 'web/check-email-exists/' + email
        );
    }
    // resetPasswordLink(email) {
    //     return this.http.post(
    //         this.env.siteApiUrl + 'web/reset_password_link',
    //         email
    //
    //     );
    // }

    resetPasswordLink(params: ResetPasswordParams) {
        return this.http.post(
            this.env.siteApiUrl + 'web/reset_password_link',
            params
        );
    }

    checkDeepLinkExist(deeplink) {
        return this.http.get(
            this.env.siteApiUrl +
                'web/check-deeplink-token-subscription/' +
                deeplink
        );
    }

    saveNewpassword(reset_data: ResetData) {
        return this.http.post<response>(
            this.env.siteApiUrl + 'web/reset-new-password-subscription',
            reset_data
        );
    }

    saveProfileData(profileData: ProfileRequest) {
        return this.http.post<ApiResponse>(
            this.env.siteApiUrl + 'web/update-profile',
            profileData
        );
    }
    uploadImage(formdata) {
        return this.http.post<ImageUploadResponse>(
            this.env.siteApiUrl + 'web/upload-image',
            formdata
        );
    }

    getProfilePicture(email) {
        return this.http.get(
            this.env.siteApiUrl + 'web/get-profile-picture/' + email
        );
    }

    saveProfilePassword(data: ResetprofileData) {
        return this.http.post<resetResponse>(
            this.env.siteApiUrl + 'web/set-new-password',
            data
        );
    }

    getProfileDetails(email) {
        return this.http.get(this.env.siteApiUrl + 'web/user-details/' + email);
    }
    closeUserAccount(email) {
        return this.http.post(this.env.siteApiUrl + 'web/close-account', email);
    }

    notification(data) {
        return this.http.post(
            this.env.siteApiUrl + 'web/edit-notification',
            data
        );
    }

    listNotification(email) {
        return this.http.get(
            this.env.siteApiUrl + 'web/list-notification/' + email
        );
    }
}
